//This file is not in use hence translation not implemented
import {Button, Progress, Tabs, TabsContent, TabsList, TabsTrigger} from 'alm-react-components';
import {Textarea} from 'alm-react-components';
import {ScrollArea} from 'alm-react-components';
import {Avatar, AvatarFallback, AvatarImage} from 'alm-react-components';

import SvgIcon from '../../common/SvgIcon';

import ClassOverviewVideo from '../../../assets/images/class-overview-video.png';
import CommitmentBadge from '../../../assets/images/svgicons/commitment-badge.svg';
import LessonIcon from '../../../assets/images/svgicons/lesson-icon.svg';
import RecommendedSection from '../library-section/RecommendedSection';
import DiscussionUser1 from '../../../assets/images/UserImage.png';
import {useTranslation} from 'react-i18next';

const ClassOverview = () => {
  const {t} = useTranslation();
  return (
    <>
      <section className=" h-fit">
        <div className="gap-6 xl:gap-6 md:grid lg:grid-cols-3 py-5 mx-auto md:py-8 px-4 xl:px-32 md:px-8 lg:px-8">
          <div className="lg:col-span-2 pb-14 lg:pb-4">
            <div className="mb-6 h-3/4">
              <img
                src={ClassOverviewVideo}
                className="w-full rounded-md h-full"
                alt="class overview video image"
              />
            </div>
            <div className="gap-4 xl:gap-8 md:grid md:grid-cols-3 max-w-screen-xl">
              <div className="col-span-2 pb-4 flex flex-col">
                <h4 className="font-light tracking-wider text-xl font-barlowLight">lesson 4</h4>
                <h2 className="lg:text-xl xl:text-2xl 2xl:text-3xl font-opensansSemiBold font-opensansSemiBold text-left mt-3">
                  Live Meeting
                </h2>
                <p className="mt-3 text-base font-opensansLight tracking-wider">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                </p>
              </div>
              <div className="pb-4 flex flex-col">
                <div className="flex">
                  <Button
                    variant={'default'}
                    className="inline-flex items-center justify-center rounded-sm text-base font-opensansSemiBold w-full my-4 ml-4 py-4 px-4 h-10"
                  >
                    Finish
                  </Button>
                </div>
                <div className="flex">
                  <Button
                    variant="link"
                    className="w-full space-y-1.5 space-x-0 p-0 mx-3 mb-1 h-auto text-base font-normal bg-transparent md:min-h-10 dark:border-white hover:no-underline"
                  >
                    <div className="flex flex-col justify-center dark:text-white">
                      <div className="flex justify-center mb-2">
                        <SvgIcon
                          iconName="upload-icon" //name of svg file
                          svgProp={{
                            className: 'logo text-sm',
                            width: '23px',
                            height: '28px',
                            fill: 'transparent',
                          }}
                        />
                      </div>
                      <div>Share</div>
                    </div>
                  </Button>
                  <Button
                    variant="link"
                    className="w-full space-y-1.5 space-x-0 p-0 mx-3 mb-1 h-auto text-base font-normal bg-transparent md:min-h-10 dark:border-white hover:no-underline"
                  >
                    <div className="flex flex-col justify-center dark:text-white">
                      <div className="flex justify-center mt-1 mb-2">
                        <SvgIcon
                          iconName="bookmark-mt" //name of svg file
                          svgProp={{
                            className: 'logo text-sm',
                            width: '20px',
                            height: '28px',
                            fill: 'transparent',
                          }}
                        />
                      </div>
                      <div>Bookmark</div>
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4 md:mt-0">
            <div className="gap-5 grid grid-cols-3 dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-4 dark:focus:ring-[#3b5998]/55 me-2 mb-2 w-full">
              <div className="col-span-2 pe-4 flex flex-col text-left">
                <h4 className="font-light text-base font-barlowLight uppercase pb-0 mb-0">
                  Program
                </h4>
                <h2 className="lg:text-xl xl:text-2xl font-barlowRegular">Commitment</h2>
                <p className="mt-2 text-base font-opensansLight text-start">
                  <span className="font-opensansBold font-opensansSemiBold">4 Parts</span> (1h 58)
                </p>
              </div>
              <div className="flex align-top justify-end">
                <SvgIcon
                  iconName="leadership-progam"
                  svgProp={{
                    className: 'logo',
                    width: 84,
                    height: 60,
                  }}
                />
              </div>
            </div>

            <div className="">
              <h4 className="font-light tracking-wider text-base font-barlowLight p-2 pb-3">
                WEEK 1
              </h4>
              <ScrollArea className="class-list-item-scroller">
                <div className="flex my-1 space-x-6 lg:space-x-6 p-2 w-full md:w-[95%] lg:w-full rounded-xl relative dark:text-gray-300 dark:hover:bg-fillLightGrayCard cursor-pointer dark:hover:text-white hover:bg-transparent">
                  <div className="flex-none relative rounded-lg border bg-fillLightGrayCard hover:opacity-100 hover:bg-black md:w-[80px] md:h-[54px] lg:w-[119px] lg:h-[72px] overflow-hidden">
                    <img
                      src={LessonIcon}
                      alt="No Image"
                      className="w-full h-[inherit] object-cover bg-center lg:col-span-full"
                    />
                  </div>
                  <div className="flex flex-col w-full">
                    <p className=" font-opensansMedium text-base">lesson 1</p>
                    <p className="font-opensansSemiBold text-lg">Read & Learn</p>
                  </div>
                </div>

                <div className="flex my-1 space-x-6 lg:space-x-6 p-2 w-full md:w-[95%] lg:w-full rounded-xl relative dark:text-gray-300 dark:hover:bg-fillLightGrayCard cursor-pointer dark:hover:text-white hover:bg-transparent">
                  <div className="flex-none relative rounded-lg border bg-fillLightGrayCard md:w-[80px] md:h-[54px] lg:w-[119px] lg:h-[72px]">
                    <img
                      src={ClassOverviewVideo}
                      alt="No Image"
                      className="mx-auto center-icon absolute h-[72px]"
                    />
                  </div>
                  <div className="flex flex-col w-full">
                    <p className=" font-opensansMedium text-base">lesson 1</p>
                    <p className="font-opensansSemiBold text-lg">Read & Learn</p>
                  </div>
                </div>

                <div className="flex my-1 space-x-6 lg:space-x-6 p-2 w-full md:w-[95%] lg:w-full rounded-xl relative dark:text-gray-300 dark:hover:bg-fillLightGrayCard cursor-pointer dark:hover:text-white hover:bg-transparent">
                  <div className="flex-none relative rounded-lg border bg-fillLightGrayCard md:w-[80px] md:h-[54px] lg:w-[119px] lg:h-[72px] overflow-hidden">
                    <img
                      src={LessonIcon}
                      alt="No Image"
                      className="w-full h-[inherit] object-cover bg-center lg:col-span-full"
                    />
                  </div>
                  <div className="flex flex-col w-full">
                    <p className=" font-opensansMedium text-base">lesson 1</p>
                    <p className="font-opensansSemiBold text-lg">Read & Learn</p>
                  </div>
                </div>

                <div className="flex my-1 space-x-6 lg:space-x-6 p-2 w-full md:w-[95%] lg:w-full rounded-xl relative dark:text-gray-300 dark:hover:bg-fillLightGrayCard cursor-pointer dark:hover:text-white hover:bg-transparent">
                  <div className="flex-none relative rounded-lg border bg-fillLightGrayCard md:w-[80px] md:h-[54px] lg:w-[119px] lg:h-[72px]">
                    <img
                      src={ClassOverviewVideo}
                      alt="No Image"
                      className="mx-auto center-icon absolute h-[72px]"
                    />
                  </div>
                  <div className="flex flex-col w-full">
                    <p className=" font-opensansMedium text-base">lesson 1</p>
                    <p className="font-opensansSemiBold text-lg">Read & Learn</p>
                  </div>
                </div>

                <div className="flex my-1 space-x-6 lg:space-x-6 p-2 w-full md:w-[95%] lg:w-full rounded-xl relative dark:text-gray-300 dark:hover:bg-fillLightGrayCard cursor-pointer dark:hover:text-white hover:bg-transparent">
                  <div className="flex-none relative rounded-lg border bg-fillLightGrayCard md:w-[80px] md:h-[54px] lg:w-[119px] lg:h-[72px] overflow-hidden">
                    <img
                      src={LessonIcon}
                      alt="No Image"
                      className="w-full h-[inherit] object-cover bg-center lg:col-span-full"
                    />
                  </div>
                  <div className="flex flex-col w-full">
                    <p className=" font-opensansMedium text-base">lesson 1</p>
                    <p className="font-opensansSemiBold text-lg">Read & Learn</p>
                  </div>
                </div>
              </ScrollArea>
            </div>

            <div className=" flex dark:bg-fillMidGrayCard font-medium rounded-lg text-sm px-5 py-4 dark:focus:ring-[#3b5998]/55 me-2 mb-2 w-full">
              <div className="program-badge-sm flex flex-none">
                <img
                  src={CommitmentBadge}
                  className="w-full rounded-md"
                  alt="class overview video image"
                />
              </div>
              <div className="col-span-2 ps-4 flex flex-col text-left">
                <p className="mt-2 text-sm font-opensansLight text-start">
                  Earn a Complete Program badge by completing all lessons.
                </p>
                <div className="flex items-center mt-4">
                  <div className=" text-base font-opensansSemiBold pr-4">1 of 7</div>
                  <div className="flex-1 min-w-0">
                    <Progress value={10} className="w-full h-[7px] bg-fillDarkGrayCard" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="">
        <div className="">
          <div className="mr-auto w-full">
            <div className="mt-1 text-sm leading-6 md:mt-0">
              <Tabs defaultValue="overviewTab" className="w-full bg-transparent">
                <TabsList className="w-full bg-transparent items-start justify-start rounded-none h-auto p-0 border border-x-0 px-4 xl:px-32 md:px-8 lg:px-8">
                  <TabsTrigger
                    value="overviewTab"
                    className="pb-5 pt-5 font-opensansSemiBold text-lg h-auto rounded-none mx-4 ml-0 md:mx-[20px] md:ml-[0px] border-b-[4px] px-0 hover:dark:border-primary hover:dark:text-primary active:dark:border-primary "
                  >
                    Overview
                  </TabsTrigger>
                  <TabsTrigger
                    value="discussionTab"
                    className="pb-5 pt-5 font-opensansSemiBold text-lg h-auto rounded-none mx-4 md:mx-[20px] px-0"
                  >
                    Discussion
                  </TabsTrigger>
                  {/* <TabsTrigger value="transcripsTab" className="pb-5 pt-5 font-opensansSemiBold text-lg h-auto rounded-none mx:13px md:mx-[50px]">
                                    Transcripts
                                </TabsTrigger> */}
                  <TabsTrigger
                    value="mynotesTab"
                    className="pb-5 pt-5 font-opensansSemiBold text-lg h-auto rounded-none mx-4 md:mx-[00px] px-0"
                  >
                    My Notes
                  </TabsTrigger>
                </TabsList>
                <TabsContent
                  value="overviewTab"
                  className="w-full py-14 px-4 xl:px-32 md:px-8 lg:px-8"
                >
                  <div className="">
                    <h2 className="text-4xl font-barlowLight text-left pb-6">Title Here</h2>

                    <p className="text-base font-normal font-sans pb-4">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                      incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                      nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </p>

                    <p className="text-base font-normal font-sans pb-4">
                      Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore
                      eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt
                      in culpa qui officia deserunt mollit anim id est laborum.
                    </p>

                    <p className="text-base font-normal font-sans pb-4">
                      Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
                      doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                      veritatis et quasi architecto beatae vitae dicta sunt explicabo.
                    </p>

                    <p className="text-base font-normal font-sans pb-4">
                      Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
                      sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                      Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur,
                      adipisci velit, sed quia non num
                    </p>
                  </div>

                  <div className="gap-0 md:grid mx-auto pt-12">
                    <div className="border-b  border-[#434343] pb-4 px-4 xl:px-32 md:px-8 lg:px-8"></div>
                  </div>

                  <div className=" -mt-12 -mx-4 xl:-mx-32 md:-mx-8 lg:-mx-32">
                    <RecommendedSection></RecommendedSection>
                  </div>
                </TabsContent>

                <TabsContent
                  value="discussionTab"
                  className="w-full py-14 pt-8 px-4 xl:px-32 md:px-8 lg:px-8"
                >
                  <div className="">
                    {/* <h2 className="text-4xl font-barlowLight text-left pb-6">Discussion</h2> */}

                    <div className="flex ms-4 my-8 space-x-6 lg:space-x-6 relative">
                      <div className="flex-none relative">
                        <span className="relative flex h-[50px] w-[50px] shrink-0 overflow-hidden rounded-full">
                          <Avatar className="border h-[50px] w-[50px]">
                            <AvatarImage src={''} />
                            <AvatarFallback className=" bg-primary text-black font-opensansSemiBold text-lg">
                              CN
                            </AvatarFallback>
                          </Avatar>
                        </span>
                      </div>
                      <div className="flex w-full border cardBorder rounded p-[9px] ps-[13px] space-x-3">
                        <div className="inline-flex w-auto items-center rounded-2xl px-3 py-1 text-base font-normal ring-1 ring-inset bg-gray-50 text-gray-600 ring-gray-500/10 dark:bg-fillMidGrayCard dark:text-white">
                          Start a Conversation
                        </div>
                        <div className="inline-flex w-auto items-center rounded-2xl px-3 py-1 text-base font-normal ring-1 ring-inset bg-gray-50 text-gray-600 ring-gray-500/10 dark:bg-fillMidGrayCard dark:text-white">
                          Ask a Question
                        </div>
                      </div>
                    </div>

                    <div className="gap-0 md:grid mx-auto pt-3">
                      <div className="border-b  border-[#434343] pb-4 px-4 xl:px-32 md:px-8 lg:px-8"></div>
                    </div>

                    <div className="grid gap-1 w-full py-8">
                      <div className="flex my-8 space-x-6 lg:space-x-6 relative">
                        <div className="flex-none relative">
                          <span className="relative flex h-[50px] w-[50px] shrink-0 overflow-hidden rounded-full">
                            <Avatar className="border h-[50px] w-[50px]">
                              <AvatarImage src="https://github.com/shadcn.png" />
                              <AvatarFallback>CN</AvatarFallback>
                            </Avatar>
                          </span>
                        </div>
                        <div className="flex flex-col w-full">
                          <div>
                            <p className="text-base font-medium leading-none pb-2">Ana Haskin</p>
                            <p className="text-base text-normal">
                              Lorem ipsum dolor sit amet, con se ctetur adipiscing elit
                            </p>
                          </div>
                          <div className="flex space-x-4 text-base py-4  justify-between">
                            <div className="flex items-center">
                              <Button
                                variant="link"
                                size="icon"
                                className="ms-0 mx-3 ps-0 text-base dark:text-white underline"
                              >
                                Like
                              </Button>
                              <Button
                                variant="link"
                                size="icon"
                                className="mx-3 text-base dark:text-white underline"
                              >
                                Reply
                              </Button>
                            </div>
                            <div className="flex items-center text-base font-light dark:text-muted-foreground">
                              8h
                            </div>
                          </div>

                          <div className="flex my-1 space-x-6 lg:space-x-6 relative dark:bg-cardBorder p-[9px] ps-[13px] rounded max-sm:flex-col">
                            <div className="flex-none relative mx-[0!important]">
                              <span className="relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full mt-2 mx-1">
                                <Avatar>
                                  <AvatarImage src="" />
                                  <AvatarFallback className=" bg-primary text-black font-opensansSemiBold text-lg">
                                    CN
                                  </AvatarFallback>
                                </Avatar>
                              </span>
                            </div>
                            <div className="flex flex-col w-full">
                              <Textarea
                                placeholder={`${t('Common.leaveReply')}...`}
                                rows={1}
                                className="dark:bg-black border-transparent pl-3 w-full"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="flex my-8 space-x-6 lg:space-x-6 relative">
                        <div className="flex-none relative">
                          <span className="relative flex h-[50px] w-[50px] shrink-0 overflow-hidden rounded-full">
                            <Avatar className="border h-[50px] w-[50px]">
                              <AvatarImage src={DiscussionUser1} />
                              <AvatarFallback>CN</AvatarFallback>
                            </Avatar>
                          </span>
                        </div>
                        <div className="flex flex-col w-full">
                          <div>
                            <p className="text-base font-medium leading-none pb-2">Deon Meyer</p>
                            <p className="text-base text-normal">
                              Lorem ipsum dolor sit amet, con se ctetur adipiscing elit
                            </p>
                          </div>
                          <div className="flex space-x-4 text-base py-4  justify-between">
                            <div className="flex items-center">
                              <Button
                                variant="link"
                                size="icon"
                                className="ms-0 mx-3 ps-0 text-base dark:text-white underline"
                              >
                                Like
                              </Button>
                              <Button
                                variant="link"
                                size="icon"
                                className="mx-3 text-base dark:text-white underline"
                              >
                                Reply
                              </Button>
                            </div>
                            <div className="flex items-center text-base font-light dark:text-muted-foreground">
                              24h
                            </div>
                          </div>

                          <div className="flex my-1 space-x-6 lg:space-x-6 relative dark:bg-cardBorder p-[9px] ps-[13px] rounded max-sm:flex-col">
                            <div className="flex-none relative mx-[0!important]">
                              <span className="relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full mt-2 mx-1">
                                <Avatar>
                                  <AvatarImage className="" src="" />
                                  <AvatarFallback className=" bg-primary text-black font-opensansSemiBold text-lg">
                                    CN
                                  </AvatarFallback>
                                </Avatar>
                              </span>
                            </div>
                            <div className="flex flex-col w-full">
                              <Textarea
                                placeholder={`${t('Common.leaveReply')}...`}
                                rows={1}
                                className="dark:bg-black border-transparent pl-3 w-full"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabsContent>

                <TabsContent
                  value="transcripsTab"
                  className="w-full py-14 px-4 xl:px-32 md:px-8 lg:px-8"
                >
                  <div className="">
                    <h2 className="text-4xl font-barlowLight text-left pb-6">Transcripts</h2>

                    <div className="flex space-x-12 p-4 ps-0">
                      <p className="text-lg font-opensansSemiBold">00:02</p>
                      <div className="flex-1 space-y-5">
                        <p className="text-base font-medium">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                          tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                          veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                          commodo consequat.
                        </p>
                        <p className="text-base font-sans">
                          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                          dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                          proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </p>
                      </div>
                    </div>
                    <div className="flex space-x-12 p-4 ps-0">
                      <p className="text-lg font-opensansSemiBold">00:34</p>
                      <div className="flex-1 space-y-5">
                        <p className="text-base font-medium">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                          tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                          veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                          commodo consequat.
                        </p>
                        <p className="text-base font-sans">
                          Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                          dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                          proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </p>
                      </div>
                    </div>
                  </div>
                </TabsContent>

                <TabsContent
                  value="mynotesTab"
                  className="w-full py-14 px-4 xl:px-32 md:px-8 lg:px-8"
                >
                  <div className="">
                    <h2 className="text-4xl font-barlowLight text-left pb-6">My Notes</h2>

                    <div className="max-w-screen-xl mt-3">
                      <h4 className="font-light tracking-wider text-base font-barlowLight">
                        {t('Common.watchingNow')}
                      </h4>
                      <h2 className="text-xl font-sans font-normal text-left mt-1 mb-6">
                        Step 1: <span className=" text-2xl">Read & Learn</span>
                      </h2>
                      <div className="mt-3 text-base font-opensansLight tracking-wider">
                        <Textarea placeholder="Type your answer here..." rows={10} className="" />
                        <div className="flex justify-end">
                          <Button
                            variant={'default'}
                            disabled
                            className="inline-flex rounded-sm text-base font-opensansSemiBold my-4 ml-4 py h-10 px-7 min-w-48"
                          >
                            Save
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabsContent>
              </Tabs>
            </div>
          </div>
        </div>
      </section>

      {/* <div className="grid grid-cols-3 gap-4">
            <div className="col-span-2 ...">01</div>
            <div className="...">02</div>
        </div> */}
    </>
  );
};
export default ClassOverview;
